import { createAction, props } from '@ngrx/store';
import { Vehicle } from '@polaris-customerweb/sharedcomponents.garage';
import {
    VehicleCategory,
    VehicleMake,
    VehicleModel,
    VehicleYear,
} from './models/industry-dropdowns.model';

export enum VehicleActionTypes {
    addVehicle = '[vehicle] add user vehicle',
    addVehicleSelectCategory = '[Add Vehicle] select category',
    addVehicleSelectMake = '[Add Vehicle] select make',
    addVehicleSelectYear = '[Add Vehicle] select year',
    deleteVehicle = '[vehicle] delete user vehicle',
    getActiveAlerts = '[vehicle alerts] Get Vehicle Alerts',
    getActiveAlertsSuccess = '[vehicle alerts] Get Vehicle Alerts Success',
    getActiveAlertsFail = '[vehicle alerts] Get Vehicle Alerts Failure',
    getVinInfo = '[Vehicle Info] Get Vehicle Info',
    getVehicleSecurity = '[Vehicle Security] Get Vehicle Security',
    getVehicleCategories = '[Add Vehicle] Get Vehicle Categories',
    getVehicleCategoriesSuccess = '[Add Vehicle] Get Vehicle Categories Success',
    getVehicleCategoriesFail = '[Add Vehicle] Get Vehicle Categories Fail',
    getVehicleMakes = '[Add Vehicle] Get Vehicle Makes',
    getVehicleMakesSuccess = '[Add Vehicle] Get Vehicle Makes Success',
    getVehicleMakesFail = '[Add Vehicle] Get Vehicle Makes Fail',
    getVehicleYears = '[Add Vehicle] Get Vehicle Years',
    getVehicleYearsSuccess = '[Add Vehicle] Get Vehicle Years Success',
    getVehicleYearsFail = '[Add Vehicle] Get Vehicle Years Fail',
    getVehicleModels = '[Add Vehicle] Get Vehicle Models',
    getVehicleModelsSuccess = '[Add Vehicle] Get Vehicle Models Success',
    getVehicleModelsFail = '[Add Vehicle] Get Vehicle Models Fail',
    getVehiclesSuccess = '[vehicle] get user vehicles success',
    getVehicleSecuritySuccess = '[Vehicle Security] Get Vehicle Security Success',
    getVehicleSecurityFail = '[Vehicle Security] Get Vehicle Security Failure',
    invalidateVehicleCache = '[vehicle] Invalidate vehicle cache',
    setVehicleSecurity = '[Vehicle Toggle] Set Vehicle Security',
    setVehicleSecuritySuccess = '[Vehicle Security] Set Vehicle Security Success',
    setVehicleSecurityFail = '[Vehicle Security] Set Vehicle Security Failure',
    setActiveVehicleById = '[vehicle] set active vehicle id',
    setVehiclesForUser = '[vehicle] set vehicles for user',
    updateVehicle = '[vehicle] update user vehicle',
}

export const SetVehiclesForUser = createAction(
    VehicleActionTypes.setVehiclesForUser,
    props<{ vehicles: Vehicle[] }>()
);

export const SetActiveVehicleId = createAction(
    VehicleActionTypes.setActiveVehicleById,
    props<{ vehicleId: string }>()
);

export const AddVehicle = createAction(
    VehicleActionTypes.addVehicle,
    props<{ vehicle: Vehicle }>()
);

export const AddVehicleSelectCategory = createAction(
    VehicleActionTypes.addVehicleSelectCategory,
    props<{ categoryId: string }>()
);

export const AddVehicleSelectMake = createAction(
    VehicleActionTypes.addVehicleSelectMake,
    props<{ categoryId: string; makeId: string }>()
);

export const AddVehicleSelectYear = createAction(
    VehicleActionTypes.addVehicleSelectYear,
    props<{ categoryId: string; makeId: string; year: number }>()
);

export const UpdateVehicle = createAction(
    VehicleActionTypes.updateVehicle,
    props<{ vehicle: Vehicle }>()
);

export const DeleteVehicle = createAction(
    VehicleActionTypes.deleteVehicle,
    props<{ id: string }>()
);

export const InvalidateVehicleCache = createAction(
    VehicleActionTypes.invalidateVehicleCache
);

export const GetUserVehiclesSuccess = createAction(
    VehicleActionTypes.getVehiclesSuccess,
    props<{ vehicles: Vehicle[] }>()
);

export const GetVinInfo = createAction(
    VehicleActionTypes.getVinInfo,
    props<{ vehicles: Vehicle[] }>()
);

export const GetVehicleSecurity = createAction(
    VehicleActionTypes.getVehicleSecurity,
    props<{ vehicleId: string }>()
);

export const GetVehicleCategories = createAction(
    VehicleActionTypes.getVehicleCategories
);

export const GetVehicleCategoriesSuccess = createAction(
    VehicleActionTypes.getVehicleCategoriesSuccess,
    props<{ vehicleCategories: VehicleCategory }>()
);

export const GetVehicleCategoriesFail = createAction(
    VehicleActionTypes.getVehicleCategoriesFail,
    props<{ errorMessage: string }>()
);

export const GetVehicleMakes = createAction(
    VehicleActionTypes.getVehicleMakes,
    props<{ categoryId: string }>()
);

export const GetVehicleMakesSuccess = createAction(
    VehicleActionTypes.getVehicleMakesSuccess,
    props<{
        vehicleMakes: VehicleMake;
    }>()
);

export const GetVehicleMakesFail = createAction(
    VehicleActionTypes.getVehicleMakesFail,
    props<{ errorMessage: string }>()
);

export const GetVehicleYears = createAction(
    VehicleActionTypes.getVehicleYears,
    props<{ categoryId: string; makeId: string }>()
);

export const GetVehicleYearsSuccess = createAction(
    VehicleActionTypes.getVehicleYearsSuccess,
    props<{
        vehicleYears: VehicleYear;
    }>()
);

export const GetVehicleYearsFail = createAction(
    VehicleActionTypes.getVehicleYearsFail,
    props<{ errorMessage: string }>()
);

export const GetVehicleModels = createAction(
    VehicleActionTypes.getVehicleModels,
    props<{ categoryId: string; makeId: string; year: number }>()
);

export const GetVehicleModelsSuccess = createAction(
    VehicleActionTypes.getVehicleModelsSuccess,
    props<{
        vehicleModels: VehicleModel;
    }>()
);

export const GetVehicleModelsFail = createAction(
    VehicleActionTypes.getVehicleModelsFail,
    props<{ errorMessage: string }>()
);

export const GetVehicleSecuritySuccess = createAction(
    VehicleActionTypes.getVehicleSecuritySuccess,
    props<{
        vehicleId: string;
        bumpAlertDisabled?: boolean;
        theftAlertDisabled?: boolean;
    }>()
);

export const GetVehicleSecurityFail = createAction(
    VehicleActionTypes.getVehicleSecurityFail,
    props<{ errorMessage: string }>()
);

export const SetVehicleSecurity = createAction(
    VehicleActionTypes.setVehicleSecurity,
    props<{ vin: string; alertsDisabled: boolean }>()
);

export const SetVehicleSecuritySuccess = createAction(
    VehicleActionTypes.setVehicleSecuritySuccess,
    props<{ bumpAlertDisabled: boolean; theftAlertDisabled: boolean }>()
);

export const SetVehicleSecurityFail = createAction(
    VehicleActionTypes.setVehicleSecurityFail,
    props<{ errorMessage: string }>()
);
